import React from 'react';
import Image from 'next/image';
import OyenAvatar from '@assets/images/PA.svg';
import { useTranslation } from 'next-i18next';

interface iMainHeaderProps {
  title: string;
  description?: string;
}

const MainHeader: React.FC<iMainHeaderProps> = ({
  title,
  description = "Let's get you signed up!",
}) => {
  const { t: tpc } = useTranslation('common');

  return (
    <div className="space-y-2">
      <div className="flex flex-row items-center space-x-3">
        <div className="w-16 h-16 pt-3 pl-1.5 pr-1.5 rounded-full overflow-hidden bg-primary">
          <Image src={OyenAvatar} width={60} height={60} alt="" />
        </div>
        <div>
          <p className="text-lg font-medium">{tpc('Oyen')}</p>
          <p className="text-gray-500">{description}</p>
        </div>
      </div>
      <p className="text-lg font-medium">{title}</p>
    </div>
  );
};

export default MainHeader;
